module.exports = __webpack_public_path__ + "static/Element55-53a663c1845bd240f71563a42a942875.png";